import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=6db47534&scoped=true&"
import script from "./DetailsPanel.vue?vue&type=script&lang=js&"
export * from "./DetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailsPanel.vue?vue&type=style&index=0&id=6db47534&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db47534",
  null
  
)

export default component.exports